import Vue from 'vue'
import {
	InputNumber,
} from 'element-ui'

import '~/assets/style/element-theme/element-variables.scss'

Vue.use(InputNumber)
